<script setup>
import { ref, reactive, defineProps, defineEmits, onMounted, watch } from "vue";
import { apiQuery } from "@/api/j24api";

const props = defineProps({
  selected: Object,
  license: Object,
});
const emit = defineEmits(["Back"]);
const logs = reactive([]);
const loading = ref(false);
onMounted(() => {
  getLogs();
});

watch(props.selected, (newVal) => {
  logs.length = 0;
  if (newVal) {
    getLogs();
  }
});

function goBack() {
  emit("Back");
}

async function getLogs() {
  loading.value = true;
  logs.length = 0;
  // date from 24 hours ago
  let dateFrom = new Date();
  dateFrom.setDate(dateFrom.getDate() - 1);
  let dateTo = new Date();
  let result = await apiQuery("ELA", "patching/patchingManagement", {
    action: "getPatchLogs",
    id: props.license._id,
    dateFrom: dateFrom.toISOString(),
    dateTo: dateTo.toISOString(),
    type: "installUpdate",
    name: props.selected.name,
    version: props.selected.version,
    status: props.selected.status,
  });
  if (result.length) {
    logs.push(...result);
  }
  loading.value = false;
}

const headers = [
  { title: "Device Serial", value: "serial", sortable: true },
  { title: "Date", value: "datetime", sortable: true },
  { title: "Status", value: "status", sortable: true },
  { title: "Updating From", value: "updatingFromShortVersion", sortable: true },
  { title: "Path", value: "path", sortable: true },
];

// Convert date time to relative time either seconds, minutes, hours, or days if more than 3 days return date
const formatDate = (date) => {
  const now = new Date();
  const diff = Math.abs(now - new Date(date));
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 7) {
    return new Date(date).toLocaleString();
  } else if (days > 0) {
    return `${days} days ago`;
  } else if (hours > 0) {
    if (hours === 1) {
      return "1 hour ago";
    }
    return `${hours} hours ago`;
  } else if (minutes > 0) {
    if (minutes === 1) {
      return "1 minute ago";
    }
    return `${minutes} minutes ago`;
  } else {
    return `${seconds} seconds ago`;
  }
};
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="logs"
    item-value="_id"
    :loading="loading"
  >
    <template v-slot:[`item.datetime`]="{ item }">
      {{ formatDate(item.datetime) }}
    </template>
  </v-data-table>
</template>
